export default "__VITE_ASSET__CcdCtkfY__"